export function calculateModalPosition(anchor, modal) {
    const anchorRect = anchor.getBoundingClientRect();
    const modalRect = modal.getBoundingClientRect();

    // Calculate top
    let top = anchorRect.top + anchorRect.height;
    if (top + modalRect.height > window.innerHeight) {
        top = anchorRect.top - modalRect.height;
    }

    // Calculate left
    let left = anchorRect.left;
    if (left + modalRect.width > window.innerWidth) {
        left = anchorRect.left - (modalRect.width - anchorRect.width);
    }

    // Return position
    return { top, left };
}
